/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(recordId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetSalesCompensationByRecord: {
        $xmlns: 'http://dobs.pa.gov/cf/record/bpm/1.0',
        RecordID: recordId
      }
    },
    blueprintArrays: ['GetSalesCompensationByRecordResponse.CF_RecordSalesCompensation'],
    blueprint: {
      salesCompensations: [
        '$..CF_RecordSalesCompensation',
        {
          id: '$..ID',
          recordId: '$..RecordID',
          recipientName: '$...RecipientName',
          recipientCRD: '$..RecipientCRD',
          bdName: '$..BDName',
          bdCRD: '$...BDCRD',
          statesOfSolicitation: '$...StatesOfSolicitation'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.salesCompensations, function(salesCompensation) {
        salesCompensation.recipientNameDisplay = salesCompensation.recipientName || '--';
        salesCompensation.recipientCRDDisplay = salesCompensation.recipientCRD || '--';
        salesCompensation.bdNameDisplay = salesCompensation.bdName || '--';
        salesCompensation.bdCRDDisplay = salesCompensation.bdCRD || '--';
      });

      deferred.resolve(response.salesCompensations);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
